import { Pipe, PipeTransform } from '@angular/core';

// Interfaces
import { Parametro } from '../interfaces/parametro.interface';

@Pipe({ name: 'parametroDescripcion' })
export class ParametroDescripcionPipe implements PipeTransform {
  transform(id: number | null, parametros: Parametro[]): string {
    if (!id || !parametros) return '';
    const parametro = parametros.find((m) => m.id === id);
    return parametro?.parametro || id.toString();
  }
}
